import React from 'react';
import { MdOutlineReceiptLong } from 'react-icons/md';
import { lazyPage } from '../lazyPage';

const OrderDeskBoardPage = lazyPage(() => import(/* webpackChunkName: "m-commerce" */ './pages/OrderDeskBoardPage'));

/**
 * Order Desk feature manifest.
 *
 * One file declares everything the shell needs to mount this feature: its route,
 * its sidebar entry, and the permission that gates both. Previously adding a module
 * meant editing four places (Go Role struct, Mongo role doc, App.js, NavigationBar's
 * featureToSidebarItems); this collapses the two front-end places into one.
 *
 * `featureName` MUST match the `feature_name` the backend emits in
 * user_permissions.permissions[] — that string is the join key for the gate.
 * See ORDER_DESK_DESIGN.md §4 (still unconfirmed: the design names the Role field
 * `OrderDeskMgmt` and the middleware key `order_desk`).
 */
const orderDeskManifest = {
    id: 'order-desk',
    featureName: 'order_desk_mgmt',
    permission: 'view',
    routes: [{ path: '/order-desk', element: <OrderDeskBoardPage /> }],
    sidebarItems: [{ text: 'Order Desk', icon: <MdOutlineReceiptLong />, link: '/order-desk' }],
};

export default orderDeskManifest;
